export enum ContextEnum {
  UPDATE = 'update',
  CREATE = 'create'
}
